import { useAuthStore } from '../stores/authStore'
import { useServerStore } from '@/shell/stores/serverStore'
import type { Server } from '../types'

// Resolves the server whose `enabledModules` subscription gates module UI
// (the primary rail filter AND the AI assistant panel). `activeServerId`
// is set ONLY while inside /servers/:id/... — Chat.tsx clears it for DMs
// and every non-server route — so without a fallback the gate would
// default to "all modules visible" (isModuleEnabled treats missing config
// as enabled). Fallback chain:
//   1. current Chat-view server (most precise)
//   2. last actively-visited server (persisted user setting)
//   3. servers[0] (single-tenant membership fallback)
// Keep PrimarySidebar (rail + AI toggle) and AppLayout (AI panel) reading
// from this one resolver so the 'ai'-off subscription hides toggle AND panel.
export function useActiveServer(): Server | undefined {
  const servers = useServerStore((s) => s.servers)
  const activeServerId = useServerStore((s) => s.activeServerId)
  const lastActiveServerId = useAuthStore((s) => s.user?.settings?.lastActiveServerId)
  return (
    servers.find((s) => s.id === activeServerId) ??
    (lastActiveServerId ? servers.find((s) => s.id === lastActiveServerId) : undefined) ??
    servers[0]
  )
}
